import { motion } from "framer-motion"
import { useInView } from "react-intersection-observer"

const BrandStrategy = () => {
    const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 })

    return (
        <div className="w-full mx-auto p-6 lg:px-12 lg:py-16 text-zinc-800 dark:text-zinc-200 text-sm" ref={ref}>
            <div className="grid lg:grid-cols-2 gap-12 items-center justify-between">

                <motion.div 
                    className="lg:w-11/12 space-y-4 lg:space-y-6 lg:order-2"
                    initial={{ opacity: 0, x: 50 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.6 }}
                >
                    <div className="flex flex-row text-zinc-800 dark:text-zinc-200 font-light items-center justify-between">
                        <div className="flex justify-start space-x-3 items-center">
                            <span className="text-purple-600 dark:text-purple-400 font-mono text-xl font-bold">01</span>
                            <span className="text-3xl lg:text-4xl font-bold text-zinc-900 dark:text-white">Developer Workflow Optimization</span>
                        </div>
                    </div>
                    <p className="text-zinc-600 dark:text-zinc-400 font-roboto font-light leading-relaxed">
                        Modern engineering velocity is defined by how well teams collaborate with AI. We conduct thorough audits of your development lifecycle to identify structural bottlenecks in code creation, peer review, and release testing.
                    </p>
                    <p className="text-zinc-600 dark:text-zinc-400 font-roboto font-light leading-relaxed">
                        By integrating tailored AI assistants, automating boilerplate generation, and setting up automated regression verification agents, we boost developer happiness and double engineering throughput.
                    </p>
                </motion.div>

                <motion.div 
                    className="mx-auto lg:w-11/12 w-full lg:order-1"
                    initial={{ opacity: 0, x: -50 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.6 }}
                >
                    <div className="p-8 rounded-2xl border border-slate-200 dark:border-purple-500/20 bg-white dark:bg-[#202222] shadow-[0_4px_20px_rgba(0,0,0,0.03)] dark:shadow-[0_0_35px_rgba(168,85,247,0.08)] hover-glow transition-all duration-300">
                        <div className="flex items-center space-x-2 mb-6">
                            <span className="w-3 h-3 rounded-full bg-red-500/80"></span>
                            <span className="w-3 h-3 rounded-full bg-yellow-500/80"></span>
                            <span className="w-3 h-3 rounded-full bg-green-500/80"></span>
                            <span className="text-[10px] text-zinc-400 dark:text-slate-500 font-mono pl-2">workflow_optimization_pipeline.sh</span>
                        </div>
                        <div className="space-y-4 font-mono text-xs">
                            <div className="flex items-center space-x-2 text-purple-600 dark:text-purple-400">
                                <span>$</span>
                                <span className="text-zinc-700 dark:text-slate-300">optimize --target-lifecycle developer-workflow</span>
                            </div>
                            <div className="text-zinc-400 dark:text-slate-500 pl-4">▸ Auditing repository structures and CI/CD pipelines...</div>
                            <div className="text-green-600 dark:text-green-400 pl-4">✔ Found 4 friction points (Code reviews, boilerplate creation, manual QA)</div>
                            <div className="text-purple-600 dark:text-purple-300 pl-4">▸ Injecting LLM-assisted developer workflow agents...</div>
                            <div className="text-green-600 dark:text-green-400 pl-4">✔ Developer agents active (expected velocity increase: +112%)</div>
                            <div className="text-zinc-700 dark:text-slate-300 pl-4 border-t border-slate-200 dark:border-slate-800/80 pt-3 flex justify-between items-center">
                                <span className="text-purple-600 dark:text-purple-400 font-semibold">Build Efficiency</span>
                                <span className="font-bold text-purple-600 dark:text-purple-400 animate-pulse">2.1x Faster</span>
                            </div>
                        </div>
                    </div>
                </motion.div>

            </div>
        </div>
    )
}

export default BrandStrategy